$(function () {
    new ClipboardJS('.toClipboard');
});